import React, {useState} from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, VStack, Heading
} from '@chakra-ui/react';
import {useProfile} from "../../../../data/profile";
import {event} from "../../../../services/analytics";

function HelpComponent({}: {}) {
  const {data: profile, mutate: mutateProfile} = useProfile()

  return (
    <VStack alignItems={"start"} fontSize={"sm"} spacing={6}>

      <VStack alignItems={"start"} spacing={2}>
        <Heading size={"md"} fontWeight={"normal"}>🔌 Connect Notion Workspace</Heading>
        <Text>
          The first step in using NotionSender is to connect your Notion workspace. You can find Notion connection
          button in Connection section.
          <br/>

          Once your Notion workspace is connected, the next step is to create an inbox or outbox database.

        </Text>

      </VStack>

      <VStack alignItems={"start"} spacing={2}>

        <Heading size={"md"} fontWeight={"normal"}>✅ Create Notion database for emails</Heading>
        <Text>
          This process involves turning your Notion database into an efficient email hub, where each database can have a
          unique email address for receiving emails.
          <br/>

          To create new database for emails you can use "Create database" button.
          <br/>
          Also, you can view existing databases that NotionSender has access to in "Notion Databases" list
        </Text>
      </VStack>


      <VStack alignItems={"start"} spacing={2}>

        <Heading size={"md"} fontWeight={"normal"}>🎥 Video Guides and Help</Heading>
        <Text>
          For video guides and FAQs, you can navigate to the NotionSender landing page where you'll find more
          information.
          You can watch videos that explain features in detail and see common questions answered in the FAQ section.
        </Text>

        <Text color={"blue.500"} as={"a"} href={"https://notionsender.com?utm_source=get_help#video-block"} target={"_blank"}>Video Guides</Text>

        <Text color={"blue.500"} as={"a"} href={"https://www.notionsender.com/blog/saving-emails-to-notion"} target={"_blank"}>Saving Emails Guide</Text>
        <Text color={"blue.500"} as={"a"} href={"https://www.notionsender.com/blog/sending-emails-from-notion"} target={"_blank"}>Sending Emails Guide</Text>


      </VStack>

      <Text>
        If you have any questions / suggestions - email us at <Text color="blue.500" as={"a"}
          href={"mailto:notionsender@gmail.com"}>notionsender@gmail.com</Text>
      </Text>


    </VStack>
  )
}

function GetHelpModal({isOpen, onClose}: any) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"xl"} scrollBehavior={"inside"}>
      <ModalOverlay/>
      <ModalContent minH={"75vh"}>
        <ModalHeader>Getting Started with NotionSender</ModalHeader>
        <ModalCloseButton/>
        <ModalBody>
          <HelpComponent/>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export function GetHelpButton() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    event({action: "open_help_modal", params: {}})
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        variant={"outline"}
        size={"sm"}
        w={{base: "100%", md: "auto"}}
        colorScheme={"gray"}
        onClick={handleOpenModal}>
        <span>Get Help</span>
      </Button>
      <GetHelpModal isOpen={isOpen} onClose={handleCloseModal}/>
    </>
  );
}
